import config from "../../../config"
import RequestManager from "../../request"
export default class Formsoin {
    constructor(data = {}) {
        this.CASAME = data.CASAME ?? false;
        this.tpamo = data.tpamo ?? false;
        this.tpcomp = data.tpcomp ?? false;
        this.DRE = data.DRE ?? false;
        this._saiprescripteur_0 = data._saiprescripteur_0 ?? "";
        this.CombonpjSelectedIndex = data.CombonpjSelectedIndex ?? -1;
        this.CombonpjItems = data.CombonpjItems ?? [];
        this.listmtItems = data.listmtItems ?? [];
        this.listmtSelectedIndex = data.listmtSelectedIndex ?? -1;
        this.datefds = data.datefds ?? "";
        this.Check2 = data.Check2 ?? false;
        this.regacc = data.regacc ?? "";
        this.Check4 = data.Check4 ?? false;
        this._mdfse_2 = data._mdfse_2 ?? false;
        // mdfse(0..4) cote desktop : enregreg_Click lit Mdfse[2], une liste vide plante
        this.mdfse = data.mdfse ?? [false, false, false, false, false];
        this.Check3 = data.Check3 ?? false;
        this.checkPrevention = data.checkPrevention ?? false;
        this.alsacemosnew = data.alsacemosnew ?? false;
        this.speciaprescripSelectedIndex = data.speciaprescripSelectedIndex ?? -1;
        this.speciaprescripItems = data.speciaprescripItems ?? [];
        this.mdfse_4 = data.mdfse_4 ?? false;
        this.fsessvitale = data.fsessvitale ?? false;
        this.fsevalid = data.fsevalid ?? false;
        this.actserie = data.actserie ?? false;
        this.signature140_2 = data.signature140_2 ?? false;
        this.dressfse = data.dressfse ?? false;
        this.TopM = data.TopM ?? false;
        this.CMU = data.CMU ?? false;
        this.CheckSMG = data.CheckSMG ?? false;
        this.noadh = data.noadh ?? "";
        this.nomoriente = data.nomoriente ?? "";
        this.prenomoriente = data.prenomoriente ?? "";
        this.Check5 = data.Check5 ?? false;
        this.decavf = data.decavf ?? false;
        this.TopMText = data.TopMText ?? "";
        this.Check1_1 = data.Check1_1 ?? false;
        this.caisseacc = data.caisseacc ?? "";
        this.centacc = data.centacc ?? "";
        this.origpj = data.origpj ?? "";
        this.datepj = data.datepj ?? "";
        this.signature140_1 = data.signature140_1 ?? false;
        this.mdfse_0 = data.mdfse_0 ?? false;
        this._mdfse_1 = data._mdfse_1 ?? false;
        this.Check6 = data.Check6 ?? false;
        this.listmtText = data.listmtText ?? "";
        this.Label27 = data.Label27 ?? "";
        this.prems = data.prems ?? false;
        this.conventionreferentnew = data.conventionreferentnew ?? false;
        this.PanelparcoursVisible = data.PanelparcoursVisible ?? false;
        this.Checkdeclmt = data.Checkdeclmt ?? false;
        this.Checkjemt = data.Checkjemt ?? false;
        this.SMGMT = data.SMGMT ?? "";
        this._combosaiprescripteur_1 = data._combosaiprescripteur_1 ?? "";
        this._combosaiprescripteur_1_items = data._combosaiprescripteur_1_items ?? [];
        this._saiprescripteur_2 = data._saiprescripteur_2 ?? "";
        this.Check1_0 = data.Check1_0 ?? false;
        this.mater = data.mater ?? false;
        this.datmat = data.datmat ?? "";
        this.dateacc = data.dateacc ?? "";
        this.idmut = data.idmut ?? "";
        this.prenomass = data.prenomass ?? "";
        this.nomass = data.nomass ?? "";
        this.c_5 = data.c_5 ?? "";
        this.S0 = data.S0 ?? false;
        this.S1 = data.S1 ?? false;
        this.S2 = data.S2 ?? false;
        this.S3 = data.S3 ?? false;
        this.S4 = data.S4 ?? false;
        this.S5 = data.S5 ?? false;
        this.S6 = data.S6 ?? false;
        this.S7 = data.S7 ?? false;
        this.S8 = data.S8 ?? false;
        this.S9 = data.S9 ?? false;
        this.S10 = data.S10 ?? false;
        this.S11 = data.S11 ?? false;
        this.S12 = data.S12 ?? false;
        this.S13 = data.S13 ?? false;
        this.S14 = data.S14 ?? false;
        this.S15 = data.S15 ?? false;
        this.tpamoCheckState = data.tpamoCheckState ?? false;
        this.tpcompCheckState = data.tpcompCheckState ?? false;
        this.Text1 = data.Text1 ?? "";
        this.t_2 = data.t_2 ?? "";
        this.t_3 = data.t_3 ?? "";
        this.Combobanque = data.Combobanque ?? "";
        this.Combobanque_items = data.Combobanque_items ?? [];
        this.Combotiers = data.Combotiers ?? "";
        this.regime = data.regime ?? "";
        this.caisse = data.caisse ?? "";
        this.centre = data.centre ?? "";
        this.List1Items = data.List1Items ?? [];
        this.UtiliseAdrTextVisible = data.UtiliseAdrTextVisible ?? false;
        this.UtiliseAdrText = data.UtiliseAdrText ?? "";
        this.UtiliseAttentatTextVisible = data.UtiliseAttentatTextVisible ?? false;
        this.r_2 = data.r_2 ?? "";
        this.Combo1Items = data.Combo1Items ?? [];
        this.Checkpasmt = data.Checkpasmt ?? false;
        this.CheckAg2035 = data.CheckAg2035 ?? false;
        // null (et pas []) : enregreg_Click ne regarnit la date du jour que si Datact == null
        this.datact = data.datact ?? null;
        this.Montantregle = data.Montantregle ?? "";
        this.optfds = data.optfds ?? [];
        this.optfdsSelectedIndex = data.optfdsSelectedIndex ?? 0;
        this.mtpaye = data.mtpaye ?? "";
        this.tierspay = data.tierspay ?? "";
        this.c = data.c ?? [];
        this.fseEnrichie = data.fseEnrichie ?? false;
        this.dateActe0 = data.dateActe0 ?? "";
    }

    static async getFormSoin() {
        const url = `${config.urlBackEnd}Formsoin/getFormsoinInstance`;
        return await RequestManager.get(url);
    }
    static async setFormSoin() {
        const url = `${config.urlBackEnd}Formsoin/setFormsoinInstance`;
        return await RequestManager.put(url);
    }

    static async initFormsoin() {
        const url = `${config.urlBackEnd}Formsoin/initFormsoin`;
        return await RequestManager.post(url);
    }
}
